module.exports = __webpack_public_path__ + "static/media/bottom_btn.9a45d370.png";